import styled from "styled-components";

export const AppContainer = styled.div`
  height: 100%;
  flex: 1 1 auto;
  overflow: auto;
  ${(props) => props.isRtl && "direction: rtl;"}

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #ffffff inset !important;
  }
`;
